import React from 'react';
import { createUseStyles } from 'react-jss';
import supportedByIcon from '../../assets/icons/supportedBy.svg';
import { theme } from '../../constants/theme';
import { capitalizeWords } from '../../utils/string.utils';

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: '10px',
    background: 'white',
    borderRadius: '6px',
    gap: '9px',
  },
  title: {
    fontFamily: 'PP Mori',
    fontWeight: '600',
    fontSize: '12px',
    color: theme.palette.primary,
  },
  ngoName: {
    fontFamily: 'PP Mori',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '12.6px',
    color: theme.palette.grey,
  },
});

interface Props {
  ngoName: string;
}

export default function ProjectSupportedBy({ ngoName }: Props) {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className={classes.title}> Projet porté par</div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '5.5px',
          alignItems: 'center',
        }}
      >
        <img
          src={supportedByIcon}
          style={{ width: '24px', height: '24px', alignSelf: 'center' }}
          alt={'supportedBy icon'}
        />
        <div className={classes.ngoName}>{capitalizeWords(ngoName)}</div>
      </div>
    </div>
  );
}
